import { createFileRoute } from '@tanstack/react-router';
import { CmsPageRenderer } from '@pages/cms-page';
import { UberUnsPage } from '@pages/uber-uns';

/**
 * Route für die Über-uns-Seite (/uber-uns).
 * Lädt CMS-Inhalte für Slug "uber-uns".
 * Fallback auf die bisherige UberUnsPage wenn CMS-Seite nicht gefunden wird
 * (Übergangsphase bis TASK-CMS-13 die Migration abschließt).
 */
export const Route = createFileRoute('/uber-uns')({
  component: function UberUnsRoute() {
    return <CmsPageRenderer slug="uber-uns" fallback={<UberUnsPage />} />;
  },
});
